import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngx-translate/core";
var ApiService = /** @class */ (function () {
    function ApiService(http, translate) {
        this.http = http;
        this.translate = translate;
        this.apiUrl = environment.apiUrl;
        this.configuratoreApiUrl = environment.configuratoreApiUrl;
    }
    ApiService.prototype.superServizio = function (jsonIn) {
        return this.http.post(this.apiUrl + 'sito/superServizio', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.search = function (jsonIn) {
        return this.http.post(this.apiUrl + 'sito/search', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.schedaSearchSchede = function (jsonIn) {
        return this.http.post(this.apiUrl + 'scheda/search?noBlock', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.schedaSearchSchedeConBlock = function (jsonIn) {
        return this.http.post(this.apiUrl + 'scheda/searchSchede', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.schedaGetScheda = function (jsonIn) {
        return this.http.post(this.apiUrl + 'scheda/getScheda', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getHomepage = function (jsonIn) {
        return this.http.post(this.apiUrl + 'homepage/getHomepage', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getPagina = function (jsonIn) {
        return this.http.post(this.apiUrl + 'pagina/getPagina', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    // fornitori
    ApiService.prototype.searchFornitori = function (jsonIn) {
        return this.http.post(this.apiUrl + 'fornitore/searchFornitori', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getCategorieFornitori = function (jsonIn) {
        return this.http.post(this.apiUrl + 'fornitore/elencoCategorie', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getsottoCategorieFornitori = function (jsonIn) {
        return this.http.post(this.apiUrl + 'fornitore/elencoSottocategorie', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getScontiFornitori = function (jsonIn) {
        return this.http.post(this.apiUrl + 'fornitore/elencoSconti', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    // Configuratore
    ApiService.prototype.strutturaConfiguratore = function () {
        return this.http.get(this.configuratoreApiUrl);
    };
    // Carrello
    ApiService.prototype.saveCarrello = function (jsonIn) {
        delete jsonIn.carrello.indirizzi;
        return this.http.post(this.apiUrl + 'carrello/saveCarrello', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.checkCoupon = function (jsonIn) {
        return this.http.post(this.apiUrl + 'carrello/checkCoupon', jsonIn);
    };
    ApiService.prototype.removeProdottoCarrello = function (jsonIn) {
        return this.http.post(this.apiUrl + 'carrello/removeProdottoCarrello', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getCarrello = function (jsonIn) {
        return this.http.post(this.apiUrl + 'carrello/getCarrello', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.saveIndirizzo = function (jsonIn) {
        return this.http.post(this.apiUrl + 'carrello/saveIndirizzo', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.getSpeseSpedizione = function (jsonIn) {
        return this.http.post(this.apiUrl + 'spedizioneSpese/getSpeseSpedizione', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    // Area Riservata
    ApiService.prototype.login = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/login', jsonIn);
    };
    ApiService.prototype.logout = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/logout', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.registrazione = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/registrazione', jsonIn);
    };
    ApiService.prototype.confirmUserMail = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/confirmUserMail', jsonIn);
    };
    ApiService.prototype.resetPassword = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/resetPassword', jsonIn);
    };
    ApiService.prototype.modificaPasswordProvvisoria = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/modificaPasswordProvvisoria', jsonIn);
    };
    ApiService.prototype.utenteRegistratoSaveIndirizzo = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/saveIndirizzo', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.utenteRegistratoUpdate = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/update', jsonIn);
    };
    ApiService.prototype.utenteRegistratoUpdatePassword = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/updatePassword', jsonIn);
    };
    ApiService.prototype.utenteRegistratoToggleNewsletter = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/toggleNewsletter', jsonIn);
    };
    ApiService.prototype.deleteAccount = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/deleteAccount', jsonIn);
    };
    ApiService.prototype.confirmDeleteAccount = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/confirmDeleteAccount', jsonIn);
    };
    // Ordini
    ApiService.prototype.ordiniUtente = function (jsonIn) {
        return this.http.post(this.apiUrl + 'ordine/ordiniUtente', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.dettaglioOrdine = function (jsonIn) {
        return this.http.post(this.apiUrl + 'ordine/dettaglioOrdine', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    // Pagamento
    ApiService.prototype.paga = function (jsonIn) {
        return this.http.post(this.apiUrl + 'payment/paga', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.ordinePagato = function (jsonIn) {
        return this.http.post(this.apiUrl + 'payment/ordinePagato', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.pagamentoAnnullato = function (jsonIn) {
        return this.http.post(this.apiUrl + 'payment/pagamentoAnnullato', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.pagamentoRifiutato = function (jsonIn) {
        return this.http.post(this.apiUrl + 'payment/pagamentoRifiutato', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.newsletter = function (jsonIn) {
        return this.http.post(this.apiUrl + 'sito/newsletter', jsonIn);
    };
    ApiService.prototype.googleMapsPlacesSearch = function (query) {
        return this.http.get("https://maps.googleapis.com/maps/api/place/findplacefromtext/json?key=" + environment.googleApiKey + "&inputtype=textquery&input=" + query + "&language=fr");
    };
    // Conattto
    ApiService.prototype.paginaContactUs = function (jsonIn) {
        return this.http.post(this.apiUrl + 'pagina/contactUs', jsonIn);
    };
    // Wishlist
    ApiService.prototype.utenteRegistratoSavePreferito = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/savePreferito', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.utenteRegistratoDeletePreferito = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/deletePreferito', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.utenteRegistratoGetWishlist = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/getWishlist', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    ApiService.prototype.utenteRegistratoShareWishlist = function (jsonIn) {
        return this.http.post(this.apiUrl + 'utenteRegistrato/shareWishlist', jsonIn).pipe(map(function (res) { return res.result; }));
    };
    /** @nocollapse */ ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.TranslateService)); }, token: ApiService, providedIn: "root" });
    return ApiService;
}());
export { ApiService };
var Scheda = /** @class */ (function () {
    function Scheda() {
    }
    return Scheda;
}());
export { Scheda };
var Carrello = /** @class */ (function () {
    function Carrello() {
        this.prodotti = [];
        this.indirizzi = [];
        this.prodottiDaInstallare = [];
    }
    return Carrello;
}());
export { Carrello };
var ProdottoCarrello = /** @class */ (function () {
    function ProdottoCarrello() {
    }
    return ProdottoCarrello;
}());
export { ProdottoCarrello };
var Indirizzo = /** @class */ (function () {
    function Indirizzo() {
    }
    return Indirizzo;
}());
export { Indirizzo };
var RegistrazioneRequest = /** @class */ (function () {
    function RegistrazioneRequest() {
    }
    return RegistrazioneRequest;
}());
export { RegistrazioneRequest };
